import { FC } from "react";
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from "@chakra-ui/react";

export interface ButtonProps extends Omit<ChakraButtonProps, "colorScheme"> {
  colorSchema: "brand" | "neutral";
  variant?: "solid" | "outline" | "ghost" | "subtle";
  size?: "xs" | "sm" | "md";
  fullWidth?: boolean;
  /** Suporte a uso com as="a" */
  href?: string;
  target?: string;
}

export const Button: FC<ButtonProps> = ({
  colorSchema,
  variant = "solid",
  size = "md",
  fullWidth,
  children,
  ...props
}) => {
  return (
    <ChakraButton
      colorScheme={colorSchema}
      variant={variant}
      size={size}
      w={fullWidth ? "100%" : props.w}
      h={props.h || (size === "sm" ? "36px" : size === "xs" ? "28px" : "40px")}
      {...props}
    >
      {children}
    </ChakraButton>
  );
};
